var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoMobileMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 133,
    viewBox: "0 0 93 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_130_325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.2298 93.8967L37.9667 103.374L33.5956 99.015L26.5708 92.0102V64.2949C30.7727 66.2868 35.2527 67.6332 39.8586 68.2885V86.5465L47.2298 93.8967Z",
    fill: "#910520"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4293 113.042V133H53.1439V118.508L50.0234 115.396L56.6649 108.771L59.407 106.039L66.4293 113.042Z",
    fill: "#910520"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.098 56.7291L46.0579 62.8077L21.8976 57.7875L6.86523 26.941H85.2531L75.098 56.7291Z",
    fill: "#910520"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93 0V24.8389C93.008 33.6153 90.5145 42.2133 85.8103 49.6309C81.106 57.0485 74.3846 62.9804 66.4293 66.7352V92.0102L55.8836 102.526L53.1439 105.258L46.5099 111.885L39.8758 118.5V132.993H26.5708V113.042L53.1439 86.5465V70.7386C48.7378 71.3658 44.2647 71.3658 39.8586 70.7386C35.2527 70.0833 30.7727 68.7369 26.5708 66.745C18.614 62.9895 11.8916 57.0561 7.18717 49.6366C2.48278 42.217 -0.00978099 33.617 2.88446e-05 24.8389V0H13.2854V24.8389C13.2854 33.6229 16.7848 42.0471 23.0137 48.2584C29.2427 54.4696 37.691 57.959 46.5 57.959C55.3091 57.959 63.7574 54.4696 69.9863 48.2584C76.2153 42.0471 79.7147 33.6229 79.7147 24.8389V0H93Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_130_325"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93,
    height: 133,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMobileMenu);
export default __webpack_public_path__ + "static/media/logo_mobile_menu.bdc1bba313842a53999259dcda59e3e6.svg";
export { ForwardRef as ReactComponent };